module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "main"
  }, [_c('div', {
    ref: "loading",
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../assets/img/spinner.gif")
    }
  }), _c('p', [_vm._v("Chargement...")])]), _c('execute-header-bar'), (_vm.projectReady) ? _c('div', {
    staticClass: "main__execute"
  }, [_c('iframe', {
    staticClass: "execution",
    style: (_vm.iframeStyle),
    attrs: {
      "src": _vm.iframeUrl,
      "frameborder": "0",
      "scrolling": "no",
      "onmousewheel": ""
    }
  })]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7cf1e53d!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/execute/Execute.vue
// module id = 599
// module chunks = 2